/* Kokgeheimen – "Direct bestellen": in de winkelwagen en meteen naar de kassa. */
(function () {
  'use strict';
  if (window.__kgnlInit) return;
  window.__kgnlInit = true;

  var routes = (window.routes || {});
  var CART_ADD = routes.cart_add_url || '/cart/add';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function jsonUrl(u) { return u.indexOf('.js') === -1 ? u + '.js' : u; }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', !!on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function showError(btn, msg) {
    var box = null;
    if (btn) {
      var scope = btn.closest('[data-kgnl-scope]') || btn.parentElement;
      if (scope) box = scope.querySelector('[data-kgnl-error]');
    }
    if (!box) box = document.querySelector('[data-kgnl-error]');
    if (!box) { window.alert(msg); return; }
    box.textContent = msg;
    box.hidden = false;
  }

  function variantFor(btn) {
    var form = btn ? btn.closest('form') : null;
    if (form) {
      var inp = form.querySelector('input[name="id"]');
      if (inp && inp.value) return inp.value;
    }
    if (btn && btn.dataset.variantId) return btn.dataset.variantId;
    var any = document.querySelector('form[data-type="add-to-cart-form"] input.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"]');
    return any ? any.value : null;
  }

  function buyNow(btn) {
    var id = variantFor(btn);
    if (!id) { showError(btn, 'Vernieuw de pagina en probeer het opnieuw.'); return; }
    setLoading(btn, true);
    fetch(jsonUrl(CART_ADD), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'Fout');
        window.location.href = ROOT.replace(/\/$/, '') + '/checkout';
      })
      .catch(function (e) {
        setLoading(btn, false);
        showError(btn, 'Dat is helaas niet gelukt (' + (e.message || 'fout') + '). Probeer het opnieuw.');
      });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-kgnl-buy]');
      if (btn) { ev.preventDefault(); buyNow(btn); }
    });
  });
})();
